/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['assets/js/backbone-extended', 'assets/js/modules/product/model/attributeModel'], function(backboneExtended, AttributeModel) {
    return backboneExtended.NestedModel.extend({
        defaults: {
            zones: {},
            mailingGuides: null,
            shape: AttributeModel.VALUE_SHAPE_RECTANGULAR,
            orientation: AttributeModel.VALUE_ORIENTATION_BOTH,
            hasFoldLine: false,
            folding: {},
            defaultOptions: {}
        },

        initialize: function(options) {
            var zones = this.get('zones');
            zones.bleedWidth = parseFloat(zones.bleedWidth);
            zones.bleedHeight = parseFloat(zones.bleedHeight);
            zones.safeWidth = parseFloat(zones.safeWidth);
            zones.safeHeight = parseFloat(zones.safeHeight);
            zones.trimWidth = parseFloat(zones.trimWidth);
            zones.trimHeight = parseFloat(zones.trimHeight);
        }
    });
});
